import { Component } from "react";
import { Image, Box, Button } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import { H2 } from "src/atoms/typography";
import TextField from "src/components/TextField";
import { SceneLayout } from "src/components/SceneLayout";
import LoadableContent from "src/components/LoadableContent";
import getImageSrc from "src/utils/getImageSrc";
import NavigationButtons from "src/components/NavigationButtons";
import { Focus } from "src/hooks/useElementFocus";
import InvalidCredentialsDialog from "src/modules/auth/components/InvalidCredentialsDialog";
import ShowPassword from "src/components/ShowPassword";
import ForgotPassword from "../../components/ForgotPassword";

const log = window.require("electron-log");

class Login extends Component {
  state = {
    email: this.props.email || "",
    password: "",
    invalidCredentials: false,
    isProcessing: false,
    showForgotPassword: false,
    showPassword: false
  };

  handleEmailChange = ({ target }) => {
    this.setState({ email: target.value });
  };

  handlePasswordChange = ({ target }) => {
    this.setState({ password: target.value });
  };
  toggleShowPassword = () =>
    this.setState((prev) => ({ showPassword: !prev.showPassword }));

  handleSubmit = async (e) => {
    e.preventDefault();
    if (this.state.isProcessing) {
      return;
    }
    const { email, password } = this.state;
    const { logIn, onSuccess } = this.props;
    this.setState({ isProcessing: true });
    try {
      await logIn({ username: email, password });
      onSuccess();
    } catch (error) {
      log.error(error);
      this.setState({ invalidCredentials: true, isProcessing: false });
      return;
    }
  };
  openForgotPassword = () => {
    this.setState({ showForgotPassword: true });
  };
  closeForgotPassword = () => this.setState({ showForgotPassword: false });
  render() {
    const {
      invalidCredentials,
      isProcessing,
      email,
      password,
      showForgotPassword,
      showPassword
    } = this.state;
    const { t, mode, onBack, onClose } = this.props;
    const closeButtonProps = onClose
      ? { onClick: onClose, disabled: isProcessing }
      : null;
    const backButtonProps = onBack
      ? { onClick: onBack, disabled: isProcessing }
      : null;
    return (
      <>
        {showForgotPassword && (
          <ForgotPassword onDismiss={this.closeForgotPassword} />
        )}
        <InvalidCredentialsDialog
          isOpen={invalidCredentials}
          onDismiss={() => this.setState({ invalidCredentials: false })}
        />
        <NavigationButtons
          mode={mode}
          backButtonProps={backButtonProps}
          closeButtonProps={closeButtonProps}
        />
        <SceneLayout
          as="form"
          onSubmit={this.handleSubmit}
          centerProps={{ width: "320px" }}
          center={
            <>
              <Image width="176px" src={getImageSrc("account.svg")} />
              <H2 textAlign="center" color="highEmphasis" mt="24px">
                {t("familyAccount")}
              </H2>
              <Box width="100%" mt="18px">
                <TextField
                  reference={Focus.addElement}
                  type="email"
                  required
                  inputProps={{
                    autoComplete: "email"
                  }}
                  disabled={isProcessing}
                  value={email}
                  onChange={this.handleEmailChange}
                  placeholder={t("placeholders.email")}
                />
              </Box>
              <Box width="100%" mt="16px" pos="relative">
                <TextField
                  mt="16px"
                  type={showPassword ? "text" : "password"}
                  required
                  disabled={isProcessing}
                  value={password}
                  onChange={this.handlePasswordChange}
                  placeholder={t("placeholders.password")}
                  inputProps={{
                    minLength: 5,
                    autoComplete: "current-password"
                  }}
                />
                <ShowPassword
                  onChange={this.toggleShowPassword}
                  showPassword={showPassword}
                />
              </Box>

              <Button
                variant="flatPrimary"
                mt="8px"
                type="button"
                onClick={this.openForgotPassword}
                minWidth="120px"
                disabled={isProcessing}
              >
                {t("forgotPassword")}
              </Button>
            </>
          }
          bottomProps={{ mb: "24px" }}
          bottom={
            <>
              <LoadableContent showContent={!isProcessing}>
                <Button
                  variant="containedPrimary"
                  type="submit"
                  minWidth="120px"
                >
                  {t("buttons.logIn")}
                </Button>
              </LoadableContent>
            </>
          }
        />
      </>
    );
  }
}

export default withTranslation()(Login);
